// src/components/OptionsPage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

const OptionsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="container mt-5">
      <h1 className="mb-4"> Admin Options</h1>
      <div className="list-group">
        <button className="list-group-item list-group-item-action" onClick={() => navigate('/this-weeks-orders')}>
          Show This Week's Orders
        </button>
        <button className="list-group-item list-group-item-action" onClick={() => navigate('/all-orders')}>
          Show All Customer Orders
        </button>
        <button className="list-group-item list-group-item-action" onClick={() => navigate('/product-quantity-needed')}>
          Show How Much of Each Product I Need
        </button>
        <button className="list-group-item list-group-item-action" onClick={() => navigate('/delivery-addresses')}>
          Get The Delivery Addresses
        </button>
        <button className="list-group-item list-group-item-action" onClick={() => navigate('/customer-info')}>
          Get Customer Info
        </button>
        <button className="list-group-item list-group-item-action" onClick={() => navigate('/nudge-customers')}>
          Nudge Customers to Pay
        </button>


        <button className="list-group-item list-group-item-action" onClick={() => navigate('/open-orders')}>
          Open Order form
        </button>
        <button className="list-group-item list-group-item-action" onClick={() => navigate('/close-orders')}>
          Close Order form
        </button>
        <button className="list-group-item list-group-item-action" onClick={() => navigate('/edit-order')}>
          Edit A Customers Order
        </button>
        <button className="list-group-item list-group-item-action" onClick={() => navigate('/manage-menu')}>
          Manage Menus &amp; Items
        </button>
      </div>
    </div>
  );
};

export default OptionsPage;
